import { registerQuery } from 'data-fetching-client';
import { fetchThreadDeliveryIdentifierData } from '../clients/fetchThreadDeliveryIdentifierData';
export const GET_THREAD_DELIVERY_IDENTIFIER_DATA = registerQuery({
  fieldName: 'threadDeliveryIdentifierData',
  args: ['threadId'],
  fetcher: fetchThreadDeliveryIdentifierData
});